import styled from 'styled-components';

export const MobileMainContainer = styled.div`
  height: 100vh;
  background: #fff;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 0px;
  }
`